const routes = [
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('./pages/Entry.vue'),
    meta: {
      requiresAuth: true,
      title: 'eRank — Calendar',
      metaTags: [
        {
          name: 'description',
          content: 'View postal holidays from around the world and see the top keywords from the previous year for any month.',
        },
        {
          page_slug: 'calendar',
        },
      ],
    },
    beforeEnter: () => {
      return { name: 'dashboard' };
    },
  },
];

export default routes; 